import { render, staticRenderFns } from "./TransitionElements.vue?vue&type=template&id=7880a989&scoped=true"
import script from "./TransitionElements.vue?vue&type=script&lang=js"
export * from "./TransitionElements.vue?vue&type=script&lang=js"
import style0 from "./TransitionElements.vue?vue&type=style&index=0&id=7880a989&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880a989",
  null
  
)

export default component.exports